import { render, staticRenderFns } from "./editRecord.vue?vue&type=template&id=3b9136e7&scoped=true&"
import script from "./editRecord.vue?vue&type=script&lang=js&"
export * from "./editRecord.vue?vue&type=script&lang=js&"
import style0 from "./editRecord.vue?vue&type=style&index=0&id=3b9136e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9136e7",
  null
  
)

export default component.exports